import React from "react";
import { __ } from '@wordpress/i18n';
import { H2 } from '../../../../ui/style';

const SiteColors = () => {
	return (
		<>
			<H2>{__('Select Your Colors', 'astra-sites')}</H2>
		</>
	)
}

export default SiteColors;
